var map = {
	"./kjljrc-red.png": 6972,
	"./qnbsrc-red.png": 1593,
	"./qnkjyc-red.png": 2993,
	"./xkbjrc-red.png": 7743,
	"./xsxxrc-red.png": 4980,
	"./yxssrc-red.png": 3704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8655;